export interface IPaymentType {
    guid: string;
    name: string;
    disabled: boolean;
    orderNumber: number;
    orderDirection: boolean;
}

export const iniPaymentType: IPaymentType = {
    guid: "",
    name: "",
    disabled: false,
    orderNumber: 0,
    orderDirection: false,
};
